import { render, staticRenderFns } from "./IndexAdvertising.vue?vue&type=template&id=2a11dbfd&scoped=true&%3Astyle=cssVars&"
import script from "./IndexAdvertising.vue?vue&type=script&lang=ts&"
export * from "./IndexAdvertising.vue?vue&type=script&lang=ts&"
import style0 from "./IndexAdvertising.vue?vue&type=style&index=0&id=2a11dbfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11dbfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
